import React, { useEffect, useRef, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import "../App.css";
import "../fire.scss";
import { AnimatePresence } from "framer-motion";
import Footer from "../Components/Footer";
import { TonConnectUIProvider } from "@tonconnect/ui-react";
import { UserProvider } from "../context/userContext";

<script src='//whephiwums.com/sdk.js' data-zone='9674745' data-sdk='show_9674745'></script>

const tele = window.Telegram.WebApp;
const Home = () => {
const [loading, setLoading] = useState(true)
const location = useLocation();
const [hider, setHider] = useState(false);

useEffect(() => {
  const handleContextMenu = (event) => event.preventDefault();
  const handleKeyDown = (event) => {
    if ((event.ctrlKey && (event.key === 'u' || event.key === 's')) || (event.ctrlKey && event.shiftKey && event.key === 'i')) {
      event.preventDefault();
    }
  };

  document.addEventListener('contextmenu', handleContextMenu);
  document.addEventListener('keydown', handleKeyDown);

  return () => {
    document.removeEventListener('contextmenu', handleContextMenu);
    document.removeEventListener('keydown', handleKeyDown);
  };
}, []);

    useEffect(() => {
        tele.ready();
        tele.expand();
        setTimeout(() => {
          setLoading(false);
        }, 2000);
        window.Telegram.WebApp.setHeaderColor('#000');

        if (tele.HapticFeedback) {
          tele.HapticFeedback.impactOccurred("medium");
        }
        if (navigator.vibrate) {
          navigator.vibrate(100);
        }
    }, []);

    useEffect(() => {
      const visitedd = localStorage.getItem('hasVisitedBeforee');
      if (!visitedd) {
        setHider(true);
        localStorage.setItem('hasVisitedBeforee', 'true');
      }

      setTimeout(() => {
        setHider(false);
      }, 1000);
    }, []);

    const overflow = 100;
    const scrollableEl = useRef(null);

    useEffect(() => {
      const isDashboardRoute = location.pathname.startsWith('/admindashboard') || location.pathname.startsWith('/dashboard');
      
      if (isDashboardRoute) {
        document.getElementById('footermain').style.display = 'none';
      }

      if (!isDashboardRoute) {
        document.body.style.overflowY = 'hidden';
        document.body.style.marginTop = `${overflow}px`;
        document.body.style.height = `${window.innerHeight + overflow}px`;
        document.body.style.paddingBottom = `${overflow}px`;
        window.scrollTo(0, overflow);
      }
    }, [location.pathname, overflow]);

  return (
<>
<div className="w-full flex justify-center">
  <div className="w-full flex justify-center">
    <div className="flex flex-col space-y-0 w-full">
      <TonConnectUIProvider manifestUrl="https://voscoinbot.netlify.app//tonconnect-manifest.json">
        <UserProvider>
          <AnimatePresence mode="wait">
            <Outlet />
            <div id="footermain" className={`${loading || hider ? 'hidden' : 'flex'} z-30 flex fixed bottom-0 left-0 right-0 justify-center items-center`}>
              <Footer/>
            </div>
          </AnimatePresence>
        </UserProvider>
      </TonConnectUIProvider>
    </div>
  </div>
</div>
</>
  );
};

export default Home;